<template>
  <v-dialog v-if="popup" v-model="popup" max-width="500">
    <v-card :dark="!themeWhite" :light="themeWhite" :style="setBackground">
      <v-card-title>
        <div class="notice-title-style resource-color">RESOURCE</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="emitClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row v-show="!writeType">
          <v-col md="9" class="d-flex align-center">
            <span class="text-left text-h5 font-weight-bold">{{ selectBoard.title }}</span>
          </v-col>
          <v-col >
            <p><span class="bottom_txt text-right text-body-2">{{ selectBoard.insdate !== undefined ? selectBoard.insdate.slice(0, 11) : '' }}</span></p>
            <span class="bottom_txt text-right text-body-2">{{ selectBoard.insuser }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-show="writeType" cols="12" class="py-0">
            <v-text-field label="제목" v-model="selectBoard.title"></v-text-field>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-textarea hide-details :readonly="!writeType" label="내용" v-model="selectBoard.contents">
            </v-textarea>
          </v-col>
          <v-col class="pb-0" v-if="writeType">
            <v-file-input
              chips
              multiple
              show-size
              dense
              outlined
              hide-details
              accept=".png, .jpg, .pdf, .doc, .jpg, .jpeg, .zip, .ppt, .pptx"
              label="multiple file upload"
              v-model="uploadFiles"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row
          v-if="!completeGetResource">
          <v-col>
          <v-skeleton-loader
            max-width="100%"
            type="list-item-three-line"
          >
          </v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row v-if="completeGetResource && downloadFiles.length > 0">
          <v-col class="pb-0">
            <v-list class="py-0" dense :style="setBackground">
              <v-list-item-title>파일 목록</v-list-item-title>
              <template v-for="(item,index) in downloadFiles">
                <v-list-item
                  :key="item.seq"
                >
                  <v-list-item-icon>
                    <v-btn :href="getResourceUrl(item)" icon small>
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip bottom>
                        <template v-slot:activator="{on,attrs}">
                          <div class="d-inline-block text-truncate" style="max-width: 330px" v-bind="attrs" v-on="on">{{item.fileName}}</div>
                        </template>
                        <span>{{item.fileName}}</span>
                      </v-tooltip>
                      <span class="text-caption">({{item.fileSize>1000 ? (item.fileSize/1000).toFixed(1) + 'KB': item.fileSize + 'B'}})</span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon v-if="selectBoard.insuser === $store.state.user.userId && writeType">
                    <v-btn icon small @click="deleteFile(index)" >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-icon>
                </v-list-item>
                <v-divider :key="index"></v-divider>
              </template>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="selectBoard.insuser !== $store.state.user.userId && writeType" class="justify-end">
        <v-btn outlined class="btn-default" @click="save">저장</v-btn>
        <v-btn outlined class="btn-default" @click="emitClose">취소</v-btn>
      </v-card-actions>
      <v-card-actions class="justify-end" v-if="selectBoard.insuser === $store.state.user.userId"> <!-- 본인 글 열었을 때 -->
        <v-btn v-if="!writeType" outlined class="btn-default" @click="writeType = true">수정</v-btn>
        <v-btn v-if="writeType" outlined class="btn-default" @click="updateResource">저장</v-btn>
        <v-btn v-if="writeType" outlined class="btn-default" @click="deleteResource">삭제</v-btn>
        <v-btn v-if="writeType" outlined class="btn-default" @click="writeType = false">취소</v-btn>
      </v-card-actions>
    </v-card>
    <general-dialog
      title="삭제 하시겠습니까?"
      v-model="modal"
      :buttons="buttons"
    >
    </general-dialog>
  </v-dialog>
</template>

<script>
import localStore from '@/utils/localStore'
import {
  getResourceFile,
  deleteResourceFile,
  uploadResource,
  updateResource,
  deleteResource
} from '@/api/greenCommon/common'
import Message from '@/utils/message'
import store from '@/store'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import envs from '@/envs'

export default {
  name: 'ResourceDialog',
  components: {
    GeneralDialog
  },
  props: {
    writeType: {
      type: Boolean,
      default: false
    },
    board: {
      type: Object
    },
    togglePopup: {
      type: Boolean
    },
    white: {
      type: Boolean
    }
  },
  data() {
    return {
      popup: false,
      modal: false,
      deleteActionType: '',
      buttons: [
        {
          title: '확인',
          color: 'primary',
          class: 'white--text',
          outlined: true,
          handler: () => {
            this.dialogDeleteAction()
          }
        },
        {
          title: '취소',
          outlined: true,
          handler: () => {
            this.modal = false
          }
        }
      ],
      uploadFiles: [],
      downloadFiles: [],
      deleteFiles: [],
      search: {
        title: ''
      },
      showAlert: false,
      isAdmin: false,
      btnList: [
        { id: 'btnSearch2', text: '조회', icon: 'mdi-magnify' },
        {
          id: 'btnCreate2',
          text: '추가',
          icon: 'mdi-file-document-edit'
        }
      ],
      fileIndex: '',
      completeGetResource: false
    }
  },
  watch: {
    togglePopup() {
      this.init()
      if (!this.writeType) {
        this.initData()
      } else {
        this.completeGetResource = true
      }
      this.popup = true
    }
  },
  mounted() {
  },
  computed: {
    themeWhite() {
      return this.white ? this.white : !this.$vuetify.theme.dark
    },
    setBackground() {
      return this.themeWhite ? 'background-color: #fff' : 'background-color: #2A3147'
    },
    selectBoard: {
      get() {
        return this.board
      },
      set(board) {
        return board
      }
    }
  },
  methods: {
    getResourceUrl(item) {
      let baseUrl = ''
      if (process.env.NODE_ENV !== 'development') {
        // 개발 환경일 경우 API위치를 셋팅한 곳으로 정의한다.
        baseUrl = envs.buildUrl
      }
      return baseUrl + '/file/' + item.fileGuid + '/' + item.fileSeq
    },
    dialogDeleteAction() {
      if (this.deleteActionType === 'resource') {
        deleteResource(this.selectBoard).then(res => {
          Message.info('삭제 되었습니다.')
          this.modal = false
          this.emitClose()
        })
      } else {
        deleteResourceFile(this.downloadFiles[this.fileIndex]).then(res => {
          Message.info('삭제 되었습니다.')
          this.downloadFiles.splice(this.fileIndex, 1)
          this.modal = false
        })
      }
    },
    deleteFile(index) {
      this.fileIndex = index
      this.deleteActionType = 'file'
      this.modal = true
    },
    deleteResource() {
      this.deleteActionType = 'resource'
      this.modal = true
    },
    updateResource() {
      const data = new FormData()
      this.uploadFiles.forEach(item => {
        data.append('file', item)
      })
      data.append('title', this.selectBoard.title)
      data.append('contents', this.selectBoard.contents)
      data.append('upduser', store.state.user.userId)
      data.append('fileGuid', this.selectBoard.fileGuid)
      data.append('seq', this.selectBoard.seq)
      updateResource(data).then(res => {
        Message.info('저장되었습니다.')
        this.uploadFiles = []
        this.writeType = false
        this.$emit('update')
      })
    },
    save() {
      const data = new FormData()
      this.uploadFiles.forEach(item => {
        data.append('file', item)
      })
      data.append('title', this.selectBoard.title)
      data.append('contents', this.selectBoard.contents)
      data.append('insuser', store.state.user.userId)
      uploadResource(data).then(res => {
        Message.info('작성이 완료되었습니다.')
        this.uploadFiles = []
        this.emitClose()
        this.$emit('update')
      }).catch(res => {
        Message.err('파일 업로드 실패했습니다.')
      })
    },
    getResourceFile() {
      getResourceFile(this.selectBoard.seq).then(res => {
        if (res !== undefined) {
          this.downloadFiles = res
          this.completeGetResource = true
          if (this.downloadFiles.length > 0) {
            this.selectBoard.fileGuid = this.downloadFiles[0].fileGuid
          }
        }
      })
    },
    init() {
      this.downloadFiles = []
      this.uploadFiles = []
    },
    initData() {
      if (localStore.get('grp_auth') === 'usergroup001') {
        this.isAdmin = true
      }
      this.getResourceFile()
    },
    emitClose() {
      this.popup = false
    }
  }
}
</script>

<style lang="less" scoped>
.column-style {
  text-align: right;
}
.box_btn {
  display: block;
  float: right;
  height: 30px;
  margin-right: 5px;
  padding: 5px 10px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}
.box_btn.orange {
  border: 1px solid #e78800;
  color: #e78800;
}
</style>
